import type { CSSProperties, ExtractPropTypes } from 'vue'

import type Tabs from './tabs.vue'

import type { TabPaneProps } from 'ant-design-vue'
import { Key } from 'ant-design-vue/es/_util/type'

import { buildProps, definePropType } from '@ll-plus/utils'

// 页签类型：线型
export const tabsLinePaddingEnum = {
  vertical: {
    large: {
      paddingTop: '6px',
      paddingBottom: '6px',
      paddingLeft: '16px',
      paddingRight: '16px',
    },
    middle: {
      paddingTop: '5px',
      paddingBottom: '5px',
      paddingLeft: '14px',
      paddingRight: '14px',
    },
    small: {
      paddingTop: '4px',
      paddingBottom: '4px',
      paddingLeft: '12px',
      paddingRight: '12px',
    },
  },
  horizontal: {
    large: {
      paddingTop: '12px',
      paddingBottom: '12px',
      paddingLeft: '0',
      paddingRight: '0',
    },
    middle: {
      paddingTop: '12px',
      paddingBottom: '12px',
      paddingLeft: '0',
      paddingRight: '0',
    },
    small: {
      paddingTop: '8px',
      paddingBottom: '8px',
      paddingLeft: '0',
      paddingRight: '0',
    },
  },
}

// 页签类型：按钮/卡片/可编辑卡片
export const tabsCardPaddingEnum = {
  large: {
    paddingTop: '6px',
    paddingBottom: '6px',
    paddingLeft: '16px',
    paddingRight: '16px',
  },
  middle: {
    paddingTop: '5px',
    paddingBottom: '5px',
    paddingLeft: '14px',
    paddingRight: '14px',
  },
  small: {
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '12px',
    paddingRight: '12px',
  },
}

export interface Tab extends TabPaneProps {
  key: Key
  name: string
}
// props
export const tabsProps = buildProps({
  tabs: {
    type: definePropType<Tab[]>(Array),
    default: () => [],
  },
  width: {
    type: String,
  },
  height: {
    type: String,
  },
  hideAdd: {
    type: Boolean,
    default: true,
  },
  type: {
    type: String,
    default: 'line',
    values: ['line', 'card', 'editable-card', 'button'],
  },
  size: {
    type: String,
    default: 'middle',
    values: ['large', 'middle', 'small'],
  },
  // tab位置
  tabPosition: {
    type: String,
    default: 'top',
    values: ['top', 'left', 'right', 'bottom'],
  },
  // 左侧缩进
  startIndent: {
    type: Number,
    default: 0,
  },
  // 右侧缩进
  endIndent: {
    type: Number,
    default: 0,
  },
  tabWidthMode: {
    type: String,
    default: 'auto',
    values: ['fixed', 'auto', 'equal'],
  },
  tabFixedWidth: {
    type: String,
    default: '120px',
  },
  // 页签内间距
  tabPadding: {
    type: Object,
    default: () => ({}),
  },
  // 页签边框圆角
  tabBorderRadius: {
    type: String,
    default: '',
  },
  // 选中页签下划线颜色
  inkBarColor: {
    type: String,
    default: '#2e73ff',
  },
  // 选中页签下划线宽度
  inkBarWidth: {
    type: String,
    default: '2px',
  },
  // 页签样式对象
  tabBarStyle: {
    type: definePropType<CSSProperties | null>(Object),
    default: null,
  },
} as const)

export type TabsProps = ExtractPropTypes<typeof tabsProps>

export type TabsInstance = InstanceType<typeof Tabs>
